export const permissionsKeys = {
  page: 'document.find',
  pageBlockFind: 'document.find',
  pageBlockCreate: 'document.create',
  pageBlockUpdate: 'document.update',
  pageBlockRemove: 'document.remove',
} as const;
